function TiktokIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
		>
			<g clipPath="url(#a)">
				<path
					fill="var(--red)"
					fillRule="evenodd"
					d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm3.38-24.5h-2.93l.027 11.606a2.47 2.47 0 1 1-1.734-2.357v-2.975h-.761a5.43 5.43 0 1 0 5.43 5.43l-.032-6.007c1.811 1.383 4.07 1.24 4.07 1.24v-2.909c-4.232-.264-4.07-4.028-4.07-4.028Z"
					clipRule="evenodd"
				/>
			</g>
			<defs>
				<clipPath id="a">
					<path
						fill="#fff"
						d="M0 0h32v32H0z"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default TiktokIcon;
